
import gtm from '@/mixins/gtm'
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import { head } from '@/utils/head'
import { getPageBySlug } from '@/services/fetch/modules/cms'

export default {
  mixins: [gtm],

  data() {
    return {
      gtmSubsection2: 'CoCreationTermsOfUse',
      isAwaitingResponse: true,
      document: [],
    }
  },

  fetchKey: 'internal',

  async fetch() {
    const locale = this.$i18n.locale
    this.document = await getPageBySlug(locale, 'co-creation-terms-of-use')
    this.isAwaitingResponse = false
  },

  nuxtI18n: {
    parsePages: false,
    locales: ['pt-br', 'en', 'es', 'fr', 'ja', 'it'],
  },

  head() {
    if (!this.isAwaitingResponse && this.document[0]) {
      const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
      let title = this.document[0].hero.title
      const url = `${process.env.BASE_URL}${this.$route.path}`
      const canonical = url
      const description = this.$t('seo.shared.descriptionTemplate', { description: title })

      return head({
        title,
        description,
        url,
        canonical,
        htmlAttrs: { ...i18nHead.htmlAttrs },
        link: SEO.linkAlternate.setList(this.$route.name),
        breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
      })
    }
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
